// @flow

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import AvatarOrTeamLogo from 'app/common/components/AvatarOrTeamLogo';

type StateProps = {
  isTeam: boolean,
  url: string,
  name: string,
};

export const mapStateToProps = (
  state: Object,
  ownProps: { accountId: number }
): StateProps => {
  const { accountId } = ownProps;

  const account = Account.selectors.all.entity(accountId, state);
  const profile = Profile.selectors.all.entity(
    Account.selectors.ownerId(account),
    state
  );
  const isTeam = Account.selectors.isTeam(account);

  return {
    isTeam,
    url: isTeam
      ? Account.selectors.logoChoiceOrUrl(account)
      : Profile.selectors.gravatarUrl(profile),
    name: isTeam
      ? Account.selectors.name(account)
      : Profile.selectors.normalizedName(profile),
  };
};

const AvatarOrTeamLogoContainer = connect(mapStateToProps)(AvatarOrTeamLogo);

AvatarOrTeamLogoContainer.propTypes = {
  accountId: PropTypes.number,
};

export default AvatarOrTeamLogoContainer;
